/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import React from 'react';

import {Collaborator, Owner, OwnerInfo} from 'auth/PermissionConstants';
import BenchlingConfig from 'BenchlingConfig';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {OwnableInfo} from 'create-components/OwnableConstants';
import OwnableSettingsModal from 'create-components/OwnableSettingsModal';
import TemplateCollectionActions from 'notebook/entry-templates/collections/TemplateCollectionActions';

import {TemplateCollectionGraphQL} from '../../../../graphql-fragments/notebook/templates/__generated/TemplateCollectionGraphQL';
import {CreateTemplateParams} from './TemplateCollectionDAO';

interface Props {
  templateCollection: TemplateCollectionGraphQL;
  navigateOnSuccess?: boolean;
  onRequestClose: (...args: Array<any>) => any;
}

class ManageTemplateCollectionModal extends React.Component<Props> {
  _isMounted?: boolean;

  componentDidMount(): void {
    this._isMounted = true;
  }

  componentWillUnmount(): void {
    this._isMounted = false;
  }

  updateTemplateCollection = (data: CreateTemplateParams): JQueryPromise<any> =>
    TemplateCollectionActions.updateWithXHR(this.props.templateCollection.id, data);

  deleteTemplateCollection = (): JQueryPromise<any> =>
    TemplateCollectionActions.deleteWithXHR(this.props.templateCollection.id);

  render(): JSX.Element | null {
    const owner: Owner = this.props.templateCollection.ownerJson;
    const ownerInfo: OwnerInfo = {
      type: this.props.templateCollection.ownerInfoJson.type,
      memberDataPolicyId: this.props.templateCollection.ownerInfoJson.memberDataPolicyId || null,
    };
    const collaborators: Array<Collaborator> = this.props.templateCollection.collaboratorsJson.filter(
      (collaborator: any) => collaborator.id !== owner.id
    );

    const templateCollectableOwnable: OwnableInfo = {
      id: this.props.templateCollection.id,
      name: this.props.templateCollection.name,
      description: this.props.templateCollection.description,
      owner,
      ownerInfo,
      collaborators,
    };

    return (
      <OwnableSettingsModal
        navigateOnSuccess={this.props.navigateOnSuccess}
        onRequestClose={this.props.onRequestClose}
        existingOwnable={templateCollectableOwnable}
        ownableType={ModelTypeConstants.TEMPLATE_COLLECTION}
        isReadOnly={!this.props.templateCollection?.permissions?.admin}
        doSubmit={this.updateTemplateCollection}
        doDelete={
          !BenchlingConfig.ELN_ENABLE_TEMPLATE_ARCHIVING && BenchlingConfig.ENABLE_DELETE
            ? this.deleteTemplateCollection
            : null
        }
      />
    );
  }
}

export default ManageTemplateCollectionModal;
